export default __webpack_public_path__ + "static/media/Path 92.445f3ad3.svg";